'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const { string } = PropTypes

const SearchButton = createReactClass({
  propTypes: {
    searchText: string,
    pleaseWaitText: string,
    agent: string
  },

  getDefaultProps () {
    return {
      searchText: 'Search',
      pleaseWaitText: 'Please wait ...'
    }
  },

  getInitialState () {
    return {
      buttonText: this.props.searchText
    }
  },

  componentDidMount () {
    window.onpageshow = (e) => {
      if (e.persisted) window.location.reload()
    }
  },

  updateButtonText () {
    const { pleaseWaitText } = this.props
    this.setState({
      buttonText: pleaseWaitText
    })
    return true
  },

  render () {
    const { buttonText } = this.state

    return (
      <div className='form-group submit'>
        <button
          className='btn btn-primary btn-padding btn-block hxtrack'
          data-hxtrack-name='engine-search-button'
          data-track-name='search-button'
          type='submit'
          onClick={this.updateButtonText}
          dangerouslySetInnerHTML={{ __html: buttonText }}
        />
      </div>
    )
  }
})

module.exports = SearchButton



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/engine-horizontal/searchButton.jsx